import { useParams } from 'react-router-dom'
import { WhatsAppEmbeddedSignup } from '../integrations/WhatsAppEmbeddedSignup'

export function WhatsAppTab() {
  const { id } = useParams<{ id: string }>()
  const assistantId = id ? parseInt(id, 10) : undefined

  if (!assistantId) return null

  return (
    <div className="space-y-6">
      <WhatsAppEmbeddedSignup assistantId={assistantId} />
    </div>
  )
}
